import { render, staticRenderFns } from "./TabWizarr.vue?vue&type=template&id=12d1b04a&scoped=true&"
import script from "./TabWizarr.vue?vue&type=script&lang=js&"
export * from "./TabWizarr.vue?vue&type=script&lang=js&"
import style0 from "./TabWizarr.vue?vue&type=style&index=0&id=12d1b04a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d1b04a",
  null
  
)

export default component.exports